import { clearIncidentCache } from "@/services/incidentService";
import { clearSavedDecisionsCache } from "@/services/savedDecisionsService";

/** Clears device-local caches that must not leak between accounts on a shared browser. */
export function clearUserScopedLocalData(userId?: string): void {
  clearIncidentCache(userId);
  clearSavedDecisionsCache(userId);
}
